export enum ColorMutationTypes {
    LOAD_COLORS = "LOAD_COLORS",
}